import $ from 'jquery'
import ExcelModal from '@/views/parametres/import-excel-modal'

export default {
    name: 'param-examens',
    components: {
        ExcelModal
    },
    props: [],
    data() {
        return {
            exm_loading: true,
            exm_empty: false,

            fields: [
				{ key: 'examen', label: 'Type examen' }, { key: 'actions', label: 'Action.s' }
			],
			filter: "",
			perPage: 20,
			currentPage: 1,

            c_prestation: {
				id: 0,
				libelle: '',
                prix: 0
			},
            is_edit: false,

            save_loading: false,
            modal_title: 'Nouvel examen',
            exist_error: false,

            to_be_deleted: {
				id: 0,
				libelle: ''
			},
			is_confirm: false,
			del_loading: false,

            is_printing: false,
            filename: '',

            type_admission: '',
            designation: '',
            emit_action: '',
            modal_toggler: true,

            json_fields: {
                'Libellé': 'libelle',
                'Prix': 'prix',
            },

            json_data: [],
            export_filename: 'Liste_Examens.xls'
        }
    },
    computed: {
        types_examens() {
            return this.$store.getters["examens"];
        },

        exm_rows() {
            return this.types_examens.length;
        },
    },
    mounted() {
        this.refreshListeExamens()

        var d = new Date()
        var tmpstamp = d.getHours()+''+d.getMinutes()+''+d.getFullYear()

        this.filename = 'Liste_des_type_examens_'+tmpstamp
    },
    methods: {
        importExcelFile(type_admission, designation) {
            this.type_admission = type_admission
            this.designation = designation
            this.modal_toggler = (this.modal_toggler)?false:true

            this.emit_action = 'emitListExamen'

            setTimeout(() => {
                $('.excel-modal-'+type_admission).modal('show')
            }, 200);
            
        },

        refreshListeExamens() {
            this.exm_loading = true

            this.$store.dispatch("getExamens").then(() => {
                if (this.types_examens.length > 0) {
                    this.exm_empty = false

                    this.types_examens.forEach(examen => {
                        this.json_data.push({
                            'libelle' : examen.nom,
                            'prix' : (examen.prix > 0)?examen.prix:''
                        })
                    });

                } else {
                    this.exm_empty = true
                }

                this.exm_loading = false
            })
        },

        edit(data) {
            this.is_edit = true

            this.c_prestation = {
                id: data.id,
                libelle: data.nom,
                prix: 0
            }
            this.modal_title = data.nom
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

		/**
		 * Selectionne la prestation de consultation à supprimer
		 * @param {*} data 
		 */
		remove(data) {
			this.to_be_deleted = {
                id: data.id,
                libelle: data.nom
            }
		},

		/**
		 * Retirer un examen de la liste de demande
		 */
        supprimer() {
            this.del_loading = true;

            let confirm = document.getElementById('cfrm-del-exm');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false;
            }

            if (err == 0) {
                this.$store.dispatch('deleteTypeExamen', this.to_be_deleted).then((response) => {
                    
                    if (response > 0) {
                        this.successMsg('Type examen supprimé avec succès')
                    }
                    this.del_loading = false;
                    this.is_confirm = false

					this.refreshListeExamens();
					this.$refs.del_exm.click()

                    
                })
            }
        },

        addNewExamen() {
            this.is_edit = false
            this.modal_title = 'Nouvel examen'

			this.c_prestation = {
				id: 0,
				libelle: '',
                prix: 0
			}
        },

        async submit() {
            const isValid = await this.$refs.exm_form.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true

            this.$store.dispatch("addNewExamen", this.c_prestation).then((response) => {
                this.save_loading = false

                if (response > 0) {
                    this.refreshListeExamens()

                    this.$refs.exm_form.reset()
                    this.$refs.add_modal.click()

                    
                } else {
                    this.exist_error = true
                }
            })
        },

        clearError() {
            this.exist_error = false
        },

        successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

        handleBeforeGenerate() {
            let d = new Date()
            this.export_filename = 'Liste_Examens_'+d.getMilliseconds()+'.xls'
            this.is_exporting = true
        },
    }
}


